import { createQueryFilterField } from '@pesto/ui';
import { useSearchParams } from 'react-router-dom';

import { useProgramsQuery } from '../__generated__/graphql/api';

export const useProgramFilterFields = () => {
  const [searchParams] = useSearchParams();
  const { data, loading } = useProgramsQuery();
  const programs = data?.programs ?? [];

  const programFilterFields =
    programs.length > 1 || searchParams.has('programId')
      ? [
          createQueryFilterField<{ programId?: string | null }>('Program', 'programId', {
            options: programs.map((program) => ({ label: program.name, value: program.id, withCount: false })),
            variant: 'select',
          }),
        ]
      : [];

  return { programFilterFields, programsLoading: loading };
};
